<ng-container *transloco="let t; read: 'partials.agenda.blocks.break'">
  <div *ngIf="container" class="agenda-block">
    <app-agenda-exercise-headline
      [container]="container"
      [type]="'break'"
      [title]="t('break')"
    ></app-agenda-exercise-headline>
  </div>
</ng-container>
